import React, { createContext, useState, useContext } from 'react';

const RouteContext = createContext();

export function RouteProvider({ children }) {
    // Точки
    const [startPoint, setStartPoint] = useState(null);
    const [endPoint, setEndPoint] = useState(null);

    // Данные о маршруте (GeoJSON) – например, { type, geometry, properties }
    const [routeData, setRouteData] = useState(null);

    // Флаг «Встроенный» – показываем ли «итоговый» вид или нет
    const [embeddedMode, setEmbeddedMode] = useState(false);

    // По желанию можно и routeLoading/routeError хранить:
    const [routeLoading, setRouteLoading] = useState(false);
    const [routeError, setRouteError] = useState(null);

    return (
        <RouteContext.Provider value={{
            startPoint, setStartPoint,
            endPoint, setEndPoint,
            routeData, setRouteData,
            embeddedMode, setEmbeddedMode,
            routeLoading, setRouteLoading,
            routeError, setRouteError
        }}>
            {children}
        </RouteContext.Provider>
    );
}

// Хук для использования контекста:
export function useRoute() {
    return useContext(RouteContext);
}
